import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';

import {
  ClientsScreen,
  RegimesScreen,
  RolesScreen,
  UsersScreen,
  PapersScreen,
} from '../../Screens';

const SubRouter = ({ match: { url }, locations }) => {
  return (
    <Switch>
      <Route
        component={UsersScreen}
        exact
        location={locations}
        path={`${url}/users`}
      />
      <Route
        component={RegimesScreen}
        exact
        location={locations}
        path={`${url}/regimes`}
      />
      <Route
        component={RolesScreen}
        exact
        location={locations}
        path={`${url}/roles`}
      />
      <Route
        component={ClientsScreen}
        exact
        location={locations}
        path={`${url}/clients`}
      />
      <Route
        component={PapersScreen}
        exact
        location={locations}
        path={`${url}/papers`}
      />
    </Switch>
  );
};

SubRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  locations: PropTypes.object,
};

export default withRouter(SubRouter);
